import { useAtom } from "jotai";

import type { BackgroundType } from "@design-lab/shared/constants";
import { interactionModeAtom } from "@design-lab/entities/artwork";
import { BackgroundToggle } from "@design-lab/widgets/artboard/ui/tool-bar/BackgroundToggle";

import { RefineModeSelector } from "./RefineModeSelector";
import { RefineZoom } from "./RefineZoom";

type RefineBottomToolbarProps = {
  backgroundType: BackgroundType;
  onBackgroundTypeChange: (type: BackgroundType) => void;
  maxZoom?: number;
};

export function RefineBottomToolbar({
  backgroundType,
  onBackgroundTypeChange,
  maxZoom = 10
}: RefineBottomToolbarProps) {
  const [interactionMode, setInteractionMode] = useAtom(interactionModeAtom);

  return (
    <div className="bottom-14.5 absolute left-0 right-0 z-10 flex items-end justify-between px-6">
      <div className="flex items-center gap-2">
        <BackgroundToggle
          value={backgroundType}
          onValueChange={onBackgroundTypeChange}
          forceFullWidth
        />
        <RefineModeSelector value={interactionMode} onValueChange={setInteractionMode} />
      </div>

      <RefineZoom maxZoom={maxZoom} />
    </div>
  );
}
